<template>
  <div class="self-card-list">
    <!--  分割线  -->
    <div class="booking-division" />
    <!--  查询框  -->  
    <div class="booking-header-search">
      <form action="/">
        <van-search
          v-model="searchForm.value"
          placeholder="请输入渠道进行搜索"
          @search="onSearch"
          show-action
        >
          <template #action>
            <div @click="onSearch(searchForm.value)">搜索</div>
          </template>
        </van-search>
      </form>
    </div>
    <!--  分割线  -->
    <div class="booking-division" />
    <!--  历史记录列表  -->
    <div class="self-card-list-main">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div
                class="self-card-list-item"
                v-for="item in selfCardList"
                :key="item.id"
            >
                <div class="self-card-list-item-option" @click="goSelfCardDetail(item)">
                    <div class="self-card-list-item-option-content">
                        <div class="self-card-list-item-option-content-row">
                            <div style="padding-right: 10px;">{{ channelText(item.channel_names) }} ({{ item.total_count }}张)</div>
                            <div>{{ moment(new Date(item.create_time)).format("YYYY-MM-DD") }}</div>
                        </div>
                        <div class="self-card-list-item-option-content-row">
                            <div>{{ item.card_type_name }}</div>
                            <div>{{ item.card_version_name }}</div>
                        </div>
                    </div>
                    <i class="el-icon-arrow-right"></i>
                </div>
                <div class="booking-division" />
            </div>
        </van-list>
    </div>
  </div>
</template>

<script>
import { getSelfCardUserInfo } from "@/models/selfCardUser";
import moment from "moment";
import selfCardService from "@/apis/selfCard/index.js";
export default {
    data() {
        return {
            searchForm: {},
            currentUserInfo: {},
            selfCardList: [],
            loading: false,
            finished: false,
            pageInfo: {
                page_index: 0,
                page_size: 10,
            }
        };
    },
    computed: {
        channelText() {
            return function(text) {
                if (text) {
                    const channels =  text.split(",");
                    return channels.length > 1 ? channels[0] + '...' : channels[0]
                } else {
                    return text
                }
            }
        }
    },
    async created() {
        const userInfo = await getSelfCardUserInfo();
        this.currentUserInfo = userInfo;
    },
    methods: {
        moment,
        onSearch(query) {
            this.selfCardList = [];
            this.pageInfo.page_index = 1;
            this.getSelfCardList(query);
        },
        onLoad() {
            this.pageInfo.page_index++;
            this.getSelfCardList();
        },
        getSelfCardList(query = "") {
            const { currentUserInfo, pageInfo } = this;
            const params = {
                ding_user_id: currentUserInfo.user_id,
                keyword: query,
                page_index: pageInfo.page_index,
                page_size: pageInfo.page_size,
            };
            selfCardService.selfCardList(params).then((res) => {
                this.loading = false;
                if (res.page_index * res.page_size > res.total_record_count) {
                    this.finished = true;
                }
                this.selfCardList.push(...res.data);
            }).catch(() => {
                this.pageInfo.page_index--;
                this.loading = false;
            });
        },
        goSelfCardDetail(item) {
            this.$router.push({
                name: "SelfCardDetail",
                query: {
                    record_id: item.id,
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.self-card-list-item {
  &-option {
    display: flex;
    padding: 15px 20px;
    border-bottom: 1px solid rgba(0, 48, 87, 0.1);
    align-items: center;
    &-content {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        padding-right: 15px;
        &-row {
            padding: 3px 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
    }
  }
}
</style>